class CacheService {
    private _map: Map<string, any> = new Map<string, any>();

    public clear(): void {
        this._map.clear();
    }

    public delete(key: string): boolean {
        return this._map.delete(key);
    }

    public get(key: string): any | undefined {
        return this._map.get(key);
    }

    public has(key: string): boolean {

        return this._map.has(key);
    }

    public set(key: string, value: any): this {
        this._map.set(key, value);
        return this;
    }

    public size(): number {
        return this._map.size;
    }

    public keys(): string[] {
        return Array.from(this._map.keys());
    }
    public values(): any[] {
        return Array.from(this._map.values());
    }
}

// declare singleton
const cacheService = new CacheService();

export default cacheService;